export default __webpack_public_path__ + "static/media/brand6-black.f12b5862.svg";